export default "__VITE_ASSET__DETehWU4__"